'use es6';

import http from 'hub-http/clients/apiClient';
import { formatPathSlug } from 'DesignData/lib/path';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
import { BASE_API_URL } from 'DesignData/lib/url';
const BASE_API_PATH = 'designmanager/v1/raw-assets';
/**
 *  GET designmanager/v1/raw-assets/:rawAssetId/buffer
 */

export function fetch(rawAssetId) {
  return http.get(`${BASE_API_PATH}/${rawAssetId}/buffer`);
}
/**
 *  GET designmanager/v1/raw-assets/by-path/:path
 */

export function fetchByPath(path) {
  return http.get(`${BASE_API_PATH}/by-path/${formatPathSlug(path)}`, {
    query: {
      environmentId: STAGED
    }
  });
}
/**
 *  PUT designmanager/v1/raw-assets/:rawAssetId/buffer
 */

export function save(rawAssetId, data = {}) {
  return http.put(`${BASE_API_PATH}/${rawAssetId}/buffer`, {
    data
  });
}
/**
 *  PUT designmanager/v1/raw-assets/buffer/by-path/:path
 */

export function saveByPath(path, data = {}, options = {}) {
  return http.put(`${BASE_API_PATH}/buffer/by-path/${formatPathSlug(path)}`, Object.assign({
    data
  }, options));
}
/**
 *  PUT designmanager/v1/raw-assets/by-path/:path?buffer=true
 */

export function replace(path, file, updateProgress) {
  const formData = new FormData();
  formData.append('file', file);
  return http.put(`${BASE_API_PATH}/by-path/${path}?buffer=true`, {
    headers: {
      'content-type': false
    },
    data: formData,
    withXhr: xhr => {
      xhr.upload.addEventListener('progress', updateProgress, false);
    }
  });
}
/**
 *  GET designmanager/v1/raw-assets/stream/by-path/:path?portalId=:portalId&buffer=true(&updated=:updated)
 */

export function getBufferedImageURL(rawAssetPath, portalId, updated) {
  if (rawAssetPath[0] !== '/') {
    rawAssetPath = `/${rawAssetPath}`;
  } //  Cache hits will occur when replacing an image as this endpoint
  //  serving the image data does not change. Passing `updated` will
  //  bust the cache when the raw asset has been modified.


  return `${BASE_API_URL}/designmanager/v1/raw-assets/stream/by-path${rawAssetPath}?portalId=${portalId}&buffer=true&updated=${updated}`;
}
/**
 *  GET designmanager/v1/raw-assets/stream/:rawAssetId/versions/:versionId?portalId=:portalId(&updated=:updated)
 */

export function getVersionedImageURL(rawAssetId, versionId, portalId, updated) {
  return `${BASE_API_URL}/designmanager/v1/raw-assets/stream/${rawAssetId}/versions/${versionId}?portalId=${portalId}&updated=${updated}`;
}